//Locations slider swiper
if ($('.new_hero_slider').length > 0) {
    const swiper = new Swiper('.new_hero_slider', {
        // Optional parameters
        direction: 'horizontal',
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
        },
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
        },
    });
}